module.exports = __webpack_public_path__ + "fonts/OpenSans-Medium.ab21dae0.ttf";